<template>
  <nav class="navigationBottom">
    <ul>
      <li>
        <router-link @click.native="handleClick('Home')" to="/main">
          <span class="icon iconHome"></span>
          <span class="txt">홈</span>
        </router-link>
      </li>
      <li>
        <router-link @click.native="handleClick('My')" to="/my">
          <span class="icon iconMy"></span>
          <span class="txt">My</span>
        </router-link>
      </li>
      <li v-if="enableCart">
        <router-link @click.native="handleClick('Cart')" to="/cart">
          <span class="icon iconCart"></span>
          <span class="txt">장바구니</span>
          <span class="num" v-if="cartUniqueQuantity">
            {{ cartUniqueQuantity }}
          </span>
        </router-link>
      </li>
      <li>
        <router-link @click.native="handleClick('Recent')" to="/recent">
          <span class="icon iconHistory"></span>
          <span class="txt">최근본상품</span>
        </router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex'
import sendLog from '@/utils/analistic'

export default {
  computed: {
    ...mapGetters('main', ['shopId', 'enableCart']),
    ...mapGetters('cart', ['cartUniqueQuantity'])
  },
  methods: {
    handleClick(name) {
      if (this.shopId) sendLog(`Menu_${name}`, { ShopID: this.shopId })
    }
  }
}
</script>

<style lang="scss">
.navigationBottom {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  // height: 55px; safeArea
  padding: 0;
  color: #151821;
  background-color: #fff;
  border-top: 1px solid #dedfe6;
  z-index: 100;
  ul {
    max-width: 710px;
    // max-width: 100%;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
  }
  li {
    position: relative;
    display: inline-block;
    //width: 25%;
    flex: 1;
  }
  a {
    display: block;
    height: 55px;
    padding-top: 9px;
    color: #151821;
    &.active,
    &:active {
      color: #6134f1;
      .icon {
        background-position-x: -50px;
      }
    }
  }
  .icon {
    display: block;
    margin: 0 auto;
  }
  .txt {
    display: block;
    padding-top: 2px;
    text-align: center;
    font-size: 10px;
  }
  .num {
    position: absolute;
    top: 5px;
    left: 50%;
    display: block;
    width: 16px;
    height: 16px;
    padding: 3px 1px 0 0;
    margin-left: 4px;
    color: #fff;
    font-size: 11px;
    text-align: center;
    border-radius: 8px;
    background-color: #e83333;
  }
}

@media screen and (min-width: 1024px) {
  .navigationBottom {
    width: 1024px;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
